import { BasePatient } from '@se/models';
import { Queue } from '../models/estensa-models.model';
import { DeepPascalCase } from '../utils/types';

export enum NotificationType {
    Ecg = 0,
    Mps = 1,
    Association = 2,
    Worklist = 3,
    SISSWay = 4,
    Sr = 5,
}

export enum AssociationType {
    Ecg = 0,
    DDevice = 1,
    Sr = 2,
}

export enum AlarmSeverity {
    Alert = 0,
    StopAlert = 1,
    TemporizedWarning = 2,
    ExamApproved = 3,
}

export interface BaseNotification {
    notificationType: NotificationType;
    idUsers: string[];
}

export interface EcgNotification extends BaseNotification {
    readonly notificationType: NotificationType.Ecg;
    severityType: AlarmSeverity;
    idExamination: string;
    examinationDate: string;
    patient: BasePatient;
}

export enum EcgAlarmAction {
    WarningAccepted = 0,
    ExamRemoved = 1,
}

export interface MpsNotification extends BaseNotification {
    readonly notificationType: NotificationType.Mps;
    id: number;
    queue: Queue;
    delete: boolean;
    add: boolean;
}

export interface AssociationNotification extends BaseNotification {
    readonly notificationType: NotificationType.Association;
    idExamination: string;
    associationType: AssociationType;
}

export enum WorklistNotificationFormType {
    Ecg = 0,
}

export interface WorklistNotification extends BaseNotification {
    readonly notificationType: NotificationType.Worklist;
    formType: WorklistNotificationFormType;
    eventDate: string;
    idBusinessUnit?: string | null;
    idUser?: string | null;
}

export interface US2AINotification extends BaseNotification {
    readonly notificationType: NotificationType.Sr;
    idRepository: string;
    studyInstanceUid: string;
}

// Per semplificare i log.
export const notificationTypeToString: Record<NotificationType, string> = {
    [NotificationType.Association]: 'Association',
    [NotificationType.Ecg]: 'ECG',
    [NotificationType.Mps]: 'MPS',
    [NotificationType.Worklist]: 'Worklist',
    [NotificationType.SISSWay]: 'SISSWay',
    [NotificationType.Sr]: 'Sr',
};

export const alarmSeverityToString: Record<AlarmSeverity, string> = {
    [AlarmSeverity.Alert]: 'Alert',
    [AlarmSeverity.StopAlert]: 'StopAlert',
    [AlarmSeverity.TemporizedWarning]: 'TemporizedWarning',
    [AlarmSeverity.ExamApproved]: 'ExamApproved',
};

export type Notification =
    | EcgNotification
    | MpsNotification
    | AssociationNotification
    | WorklistNotification
    | US2AINotification;

export function isWorklistNotification(notification: Notification): notification is WorklistNotification {
    return notification.notificationType === NotificationType.Worklist;
}

export interface RestEvent {
    CorrelationId: string;
    Notification: DeepPascalCase<Notification>;
}
